import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const browserLang = (navigator.language || navigator.userLanguage).startsWith('tr') ? 'TR' : 'EN';
  const [language, setLanguage] = useState(localStorage.getItem("MediazoneSelectedLanguage") || browserLang);

  const setGlobalLanguage = (lang) => {
    localStorage.setItem("MediazoneSelectedLanguage", lang);
    setLanguage(lang);
  }

  return (
      <LanguageContext.Provider value={{ language, setGlobalLanguage }}>
          {children}
      </LanguageContext.Provider>
  );
};

export default LanguageProvider;
